import { SVGProps } from 'react';

export const CartIcon = ({ ...rest }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2 3L4.81045 3.46841C4.92598 3.48766 5.01974 3.57239 5.05056 3.68539L5.68182 6M8 13.5V16.7C8 16.8657 8.13431 17 8.3 17H17.5M8 13.5H18.7969C18.9196 13.5 19.0299 13.4253 19.0754 13.3114L21.8354 6.41142C21.9143 6.21436 21.7691 6 21.5569 6H5.68182M8 13.5L5.68182 6M17.5 17C16.3954 17 15.5 17.8954 15.5 19C15.5 20.1046 16.3954 21 17.5 21C18.6046 21 19.5 20.1046 19.5 19C19.5 17.8954 18.6046 17 17.5 17ZM12.5 19C12.5 20.1046 11.6046 21 10.5 21C9.39543 21 8.5 20.1046 8.5 19C8.5 17.8954 9.39543 17 10.5 17C11.6046 17 12.5 17.8954 12.5 19Z"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
